import React, { useEffect, useState } from 'react';
import store, { useAppDispatch } from 'redux/store';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { Controller, useForm, FormProvider } from 'react-hook-form';
import { getAllSkillTags } from 'redux/actions/skill-tags';
import AppStylesProvider from 'components/bs4-theme-provider';

import { render } from 'react-dom';

import _ from 'underscore';
import omit from 'lodash/omit';
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-plusplus */
import { css } from '@emotion/react';
import { quarterSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';
import t from 'react-translate';
import { getMetadataFilters } from 'redux/actions/institutions';
import useForceUpdate from 'shared/hooks/use-force-update';
import { i18nJoin, JoinMode } from 'shared/services/i18n-utils';
import CourseHomeHeader from 'courses/components/course-form-header';
import NvCheckboxDropdown from 'shared/components/inputs/nv-checkbox-dropdown';
import ConfigureEntitlementsModal from 'offerings/components/configure-entitlements-modal';
import MetadataNvDropdown from './metadata-nv-dropdown';
import { providerTypes } from '../../institutions/components/advanced-settings/integrations/lms-integration';
import { config } from '@config/config.json';

/* @ngInject */
export default function CourseFormBaseCtrl(
  $q,
  $timeout,
  $translate,
  nvUtil,
  moment,
  validationConstants,
  CourseModel,
  AlertMessages,
  CoursesManager,
  CurrentUserManager,
  InstitutionsManager,
  CurrentPermissionsManager,
) {
  const vm = this;

  vm.errors = {};
  vm.initialize = initialize;
  vm.institution = InstitutionsManager.institution;
  vm.CourseModel = CourseModel;
  vm.CurrentUserManager = CurrentUserManager;
  vm.moment = moment;
  vm.validationConstants = validationConstants;
  vm.courseTypeChanged = courseTypeChanged;
  vm.usedForChanged = usedForChanged;
  vm.defaultTypeOfRegistration = defaultTypeOfRegistration;
  vm.isRegistrationOptionAvailable = isRegistrationOptionAvailable;
  vm.getEntitlementProfileSettingName = getEntitlementProfileSettingName;
  vm.getEntitlementValuesText = getEntitlementValuesText;
  vm.isCalendarActiveFromInstitution = isCalendarActiveFromInstitution;
  vm.setDirty = setDirty;
  vm.setParentCourseId = setParentCourseId;

  /** The possible types of course duration. Note that the keys must be
   * in lowercase to match the course.durationType value received from the backend */
  vm.durationUnits = {
    hours: 'TIME.HOURS',
    days: 'TIME.DAYS',
  };

  vm.currentDurationUnit = vm.durationUnits.hours;
  vm.handleErrorResponse = handleErrorResponse;
  vm.baseSaveCourse = baseSaveCourse;
  vm.removeCoverPhoto = removeCoverPhoto;
  vm.setCourseDurationUnit = setCourseDurationUnit;
  vm.setTags = setTags;
  vm.setMetadataTags = setMetadataTags;
  vm.setRequiredField = setRequiredField;
  vm.removeRequiredField = removeRequiredField;
  vm.setHeaderDraft = setHeaderDraft;
  vm.renderReactCheckboxDropdown = renderReactCheckboxDropdown;
  vm.renderReactDropdown = renderReactDropdown;
  vm.pendingRequiredFields = pendingRequiredFields;
  vm.updateFormHeader = () => { };
  vm.reactConfigureEntitlements = null;
  vm.configureEntitlements = () => {
    vm.reactConfigureEntitlements?.();
  };
  vm.nameIsValid = nameIsValid;
  vm.onChangeCatalogId = onChangeCatalogId;

  vm.onActivityCodeChange = onActivityCodeChange;
  vm.onActivityCodeBlur = onActivityCodeBlur;
  vm.validateActivityCode = validateActivityCode;
  vm.disableValidateButton = disableValidateButton;
  vm.disableActivityCode = disableActivityCode;
  vm.hasBeenReleased = hasBeenReleased;
  vm.showSubmitButton = showSubmitButton;
  vm.hasSumTotalIntegration = hasSumTotalIntegration;
  vm.hasEdcastIntegration = hasEdcastIntegration;
  vm.getEdcastLastSyncUp = getEdcastLastSyncUp;
  vm.isActivityValidated = isActivityValidated;
  vm.showValidationError = showValidationError;
  vm.showSumTotalNotValidatedError = showSumTotalNotValidatedError;
  vm.checkRequiredFieldsAreFilled = checkRequiredFieldsAreFilled;
  vm.showSuccessMessage = showSuccessMessage;
  vm.showValidateBtn = showValidateBtn;
  vm.getValidateText = getValidateText;
  vm.shouldShowPrimaryOption = shouldShowPrimaryOption;
  vm.getIsRegistrationTypeDisabled = getIsRegistrationTypeDisabled;
  vm.getRegistrationDataQa = getRegistrationDataQa;
  vm.hasLearnUponIntegration = hasLearnUponIntegration;
  vm.workdayTopics = [];
  vm.workdayDefaultTopics = [];
  vm.toggleSelectedTopic = toggleSelectedTopic;
  vm.workdayTopicsShowError = false;
  vm.onWorkdayTopicsDropdownToggle = onWorkdayTopicsDropdownToggle;
  vm.hasWorkdayIntegration = InstitutionsManager.institution.isWorkdayLearnEnabled;
  vm.onCloseDateChange = onCloseDateChange;

  /** The maximum course/program name length, enforced by the backend */
  const MAX_NAME_LENGTH = 250;

  vm.hasLmsCourse = hasLmsCourse;
  vm.hasLxpCourse = hasLxpCourse;
  vm.isMsCalendarDisabled = isMsCalendarDisabled;
  vm.msCalendar = true;
  vm.forceShowSTValidationError = false;

  /** Array of required fields with their values */
  vm.requiredFields = {};

  vm.config = config;

  const profileSettings = InstitutionsManager.institution.profileSettings.orgLevel.filter(
    profileSetting => profileSetting.isIntegrated || profileSetting.isCsvManaged,
  );

  function initialize($scope) {
    vm.$scope = $scope;
    InstitutionsManager.requestCourses(true);

    if (!this.courseDraft) {
      this.courseDraft = angular.copy(CoursesManager.course || {});
    }

    // Workday topics initialization
    const { workdayLearnConfig } = InstitutionsManager.institution;
    const workdayTopics = workdayLearnConfig?.topics ?? [];
    const workdayDefaultTopics = workdayLearnConfig?.defaultTopics ?? [];
    // Sort topics alphabetically case-insensitive
    this.workdayTopics = _.sortBy(workdayTopics, (topic) => topic.toLowerCase());
    this.workdayDefaultTopics = workdayDefaultTopics;

    const shouldInitializeWorkdayTopics = vm.hasWorkdayIntegration && workdayTopics.length > 0;
    if (shouldInitializeWorkdayTopics) {
      // The BE stores the selected topics in the externalTopic field
      const externalTopics = CoursesManager.course?.externalTopic ?? [];
      // Workday default topics are selected by default and cannot be deselected
      this.courseDraft.selectedTopics = _.uniq([
        ...externalTopics,
        ...workdayDefaultTopics,
      ]).filter(topic => workdayTopics.includes(topic));

      this.courseDraft.externalTags = this.courseDraft.selectedTopics.join(',');
    }

    const EntitlementsModal = () => {
      const [show, setShow] = useState(false);

      useEffect(() => {
        vm.reactConfigureEntitlements = () => setShow(true);
      }, []);

      const closeModal = () => setShow(false);

      const handleEntitlementsModalClose = (entitlements) => {
        closeModal();
        $timeout(() => {
          this.courseDraft.entitlements = entitlements;
          this.courseForm.$setDirty();
        });
      };

      return (
        <ConfigureEntitlementsModal
          show={show}
          onCancel={closeModal}
          profileSettings={profileSettings}
          onClose={handleEntitlementsModalClose}
          entitlements={this.courseDraft.entitlements}
        />
      );
    };

    $scope.EntitlementsModal = EntitlementsModal;

    const CourseFormHeader = () => {
      this.updateFormHeader = useForceUpdate();
      const [showTitleError, setShowTitleError] = useState(false);

      useEffect(() => {
        // Expose setter to the controller
        this.setShowTitleError = setShowTitleError;
      }, []);

      return (
        <CourseHomeHeader
          course={this.courseDraft}
          institution={InstitutionsManager.institution}
          setHeaderDraft={this.setHeaderDraft.bind(this)}
          showTitleError={showTitleError}
        />
      );
    };

    $scope.CourseFormHeader = CourseFormHeader;
  }
  // When we get a 'catalog id taken' error from backend, on change, we need to set the validity of the form to true to remove the error message.
  function onChangeCatalogId() {
    if (!this.courseForm.catalogId.$valid) {
      this.courseForm.catalogId.$setValidity('catalogId', true, this.courseForm.catalogId);
      this.courseForm.catalogId.$showValidationMessage = false;
    } else {
      this.setDirty();
    }
  }
  function handleErrorResponse(response) {
    if (response.status === 403 && response.data.error?.code === 'error.catalog_id_taken') {
      // manually triggering catalog id field validation
      this.courseForm.catalogId.$setValidity('catalogId', false, this.courseForm.catalogId);
      this.courseForm.catalogId.$showValidationMessage = true;
    } else {
      AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
    }
  }
  function baseSaveCourse() {
    const { course } = CoursesManager;

    if (course.typeOfRegistration === CourseModel.FREE_ENROLLMENT || course.typeOfRegistration === CourseModel.FREE_ENROLLMENT_IN_INSTITUTION) {
      course.rate = undefined;
      course.beingOffered = undefined;
      course.paymentsStartAt = undefined;
      course.paymentsEndAt = undefined;
    } else if (course.typeOfRegistration === CourseModel.FREE_AND_PAID_CERTIFICATE_ENROLLMENT) {
      course.paymentsStartAt = undefined;
      course.paymentsEndAt = undefined;
    } else if (course.typeOfRegistration === CourseModel.CLOSED_ENROLLMENT) {
      course.rate = undefined;
      course.beingOffered = undefined;
      course.paymentsStartAt = undefined;
      course.paymentsEndAt = undefined;
      course.registrationCloseDate = undefined;
    }

    if (!nvUtil.isValidHex(course.headerColor)) {
      course.headerColor = null;
    }

    // Clear the duration type that is set to a default during initialization if
    // the user didn't end up inputting a duration value
    if (!course.duration) {
      course.durationType = null;
    }
    // The endpoint requires a null value instead of an empty array to update the
    // empty metadata list.
    if (!course.courseMetadata?.length) {
      course.courseMetadata = null;
    }
    return course.save().then(
      (returnedCourse) => {
        vm.errors.catalogIdTaken = false;
        return $q.resolve(returnedCourse);
      },
      (response) => {
        if (response.status === 403 && response.data.error?.code === 'error.catalog_id_taken') {
          vm.errors.catalogIdTaken = true;
          $('#main-panel').scrollTop(0);
        }
        return $q.reject(response);
      },
    );
  }
  /**
   * Checks if there are any required fields that have not been fulfilled
   * @returns {boolean}
   */
  function pendingRequiredFields() {
    let pendingField = false;
    const valuesArray = Object.values(this.requiredFields);
    pendingField = valuesArray.some(element => (typeof element === 'undefined' || element === null));
    return pendingField;
  }
  /**
   * Before allowing save button with $setDirty(), it's necesary to check if
   * all the required fields have been completed
   */
  function setDirty() {
    // Only check if requiredFields are completed in a course type offering since program does not make use of requiredFields
    if (!this.courseDraft.isProgram && this.pendingRequiredFields()) {
      this.courseForm.$setPristine();
    } else {
      this.courseForm.$setDirty();
    }
  }

  function setParentCourseId() {
    if (!this.videoSharing) {
      this.courseDraft.parentCourseId = this.courseDraft.id;
    }
    this.setDirty();
  }

  function onCloseDateChange() {
    // When closeDate is cleared, reset closeDateApplyToAll to default (true)
    if (!this.courseDraft.closeDate) {
      this.courseDraft.closeDateApplyToAll = true;
    } else if (this.courseDraft.closeDateApplyToAll === undefined) {
      // When closeDate is first set and no value exists, set default (true)
      this.courseDraft.closeDateApplyToAll = true;
    }
    this.setDirty();
  }

  function removeCoverPhoto(file) {
    const course = this.courseDraft ? this.courseDraft : CoursesManager.course;
    course.coverPhoto = undefined;
    course.coverPhotoUrl = undefined;
    this.setDirty();
  }

  function usedForChanged() {
    if (this.courseDraft?.usedFor === CourseModel.USED_FOR_DEMO && this.hasSumTotalIntegration()) {
      const defaultSumTotal = { lmsActivityCode: '', lmsActivityId: '' };
      _.extend(this.courseDraft, defaultSumTotal);
      _.extend(this.courseDraft.sumTotalIntegration, defaultSumTotal);
    }

    if (this.courseDraft.usedFor === CourseModel.USED_FOR_PRIMARY) {
      this.courseDraft.typeOfRegistration = CourseModel.CLOSED_ENROLLMENT;
    } else {
      this.courseDraft.typeOfRegistration = vm.defaultTypeOfRegistration();
    }

    this.setDirty();
  }

  function defaultTypeOfRegistration() {
    if (_.contains(InstitutionsManager.institution.courseEnrollmentTypes, '3')) {
      return 3;
    }
    return parseInt(InstitutionsManager.institution.courseEnrollmentTypes[0], 10);
  }

  function courseTypeChanged() {
    if (this.courseDraft.isProgram) {
      if (this.courseDraft.typeOfRegistration === CourseModel.OPEN_BASED_ON_ENTITLEMENTS) {
        this.courseDraft.typeOfRegistration = CourseModel.FREE_ENROLLMENT;
      }

      if (this.courseDraft.usedFor === CourseModel.USED_FOR_PRIMARY) {
        this.courseDraft.usedFor = CourseModel.USED_FOR_DEMO;
      }
    }

    // Update form state on each change of offering type
    this.setDirty();
  }

  function isRegistrationOptionAvailable(typeOfRegistration) {
    const course = this.courseDraft ? this.courseDraft : CoursesManager.course;
    const optionProvidedByAdmin = _.includes(vm.institution.courseEnrollmentTypes, typeOfRegistration.toString());

    if (optionProvidedByAdmin || (typeOfRegistration === CourseModel.CLOSED_ENROLLMENT && course.usedFor === CourseModel.USED_FOR_PRIMARY)) {
      if (course.isProgram) {
        return !_.includes([
          CourseModel.FREE_ENROLLMENT_IN_INSTITUTION,
          CourseModel.OPEN_BASED_ON_ENTITLEMENTS,
        ], typeOfRegistration.toString());
      }

      return true;
    }

    return false;
  }

  function getIsRegistrationTypeDisabled(typeOfRegistration) {
    if (this.courseDraft.usedFor === CourseModel.USED_FOR_PRIMARY) {
      return typeOfRegistration !== CourseModel.CLOSED_ENROLLMENT;
    }

    if (!vm.CurrentUserManager.user.admin && !_.includes(vm.institution.courseEnrollmentTypes, CoursesManager.course.typeOfRegistration.toString())) {
      return typeOfRegistration === CoursesManager.course.typeOfRegistration;
    }

    return false;
  }

  function getRegistrationDataQa(typeOfRegistration) {
    return ({
      [CourseModel.FREE_ENROLLMENT]: config.pendo.courseForm.registrationOpen,
      [CourseModel.CLOSED_ENROLLMENT]: config.pendo.courseForm.registrationClosed,
      [CourseModel.FREE_ENROLLMENT_IN_INSTITUTION]: config.pendo.courseForm.registrationOrgOpen,
      [CourseModel.OPEN_BASED_ON_ENTITLEMENTS]: config.pendo.courseForm.registrationEntitlements,
      // CourseModel.PAID_ENROLLMENT,
      // CourseModel.FREE_AND_PAID_CERTIFICATE_ENROLLMENT,
    })[typeOfRegistration];
  }

  function hasLmsCourse() {
    return !_.isEmpty(InstitutionsManager.institution?.lmsConnectionSettings) && CoursesManager.course?.lmsCourse;
  }

  function hasLxpCourse() {
    return !_.isEmpty(InstitutionsManager.institution?.degreedSettings) && CoursesManager.course?.degreedCourseId;
  }

  function isMsCalendarDisabled() {
    const result = this.courseDraft.isProgram || this.courseDraft.usedFor === CourseModel.USED_FOR_DEMO;
    if (result) {
      this.courseDraft.calendarEventsEnabled = false;
    } else {
      this.courseDraft.calendarEventsEnabled = this.msCalendar;
    }
    return result;
  }

  function isCalendarActiveFromInstitution() {
    return !this.courseDraft.isProgram && !this.courseDraft.isSelfPaced && this.institution.hasMicrosoftCalendarIntegration;
  }

  function hasSumTotalIntegration() {
    return vm.institution?.lmsConnectionSettings?.lms === providerTypes.SUMTOTAL;
  }

  function hasLearnUponIntegration() {
    return vm.institution?.lmsConnectionSettings?.lms === providerTypes.LEARNUPON;
  }

  function hasEdcastIntegration() {
    return !!this.courseDraft.edcastCourse;
  }

  function getEdcastLastSyncUp() {
    if (!this.courseDraft.edcastCourse.lastSyncUpAt) return '';
    const date = vm.moment(this.courseDraft.edcastCourse.lastSyncUpAt);
    return date.format('MOMENT.MONTH_DAY_YEAR_TIME');
  }

  function onActivityCodeChange() {
    const isEmpty = !this.courseDraft.lmsActivityCode;
    const isDifferent = getSumTotalProp.call(this, 'lmsActivityCode') !== this.courseDraft.lmsActivityCode;
    this.courseDraft.sumTotalIntegration.editing = !isEmpty && isDifferent;

    if (isEmpty) {
      // Reset validation state and simulate an outside click to close the popover,
      // since popover-enable=false alone does not close an already-open uib-popover.
      this.forceShowSTValidationError = false;
      $timeout(() => document.body.click(), 0);
    }
  }

  function onActivityCodeBlur() {
    this.forceShowSTValidationError = true;
  }

  function validateActivityCode() {
    const { lmsActivityCode } = this.courseDraft;
    const validatingActivity = { lmsActivityCode, validating: true, editing: false, validationError: false };
    let lmsActivityId = null;
    _.extend(this.courseDraft.sumTotalIntegration, validatingActivity);
    InstitutionsManager.validateLmsActivity({ lmsActivityCode })
      .then(({ result }) => {
        ({ lmsActivityId } = result);
      }).catch(() => {
        this.courseDraft.sumTotalIntegration.validationError = true;
      }).finally(() => {
        this.courseDraft.sumTotalIntegration.validating = false;
        this.courseDraft.sumTotalIntegration.lmsActivityId = lmsActivityId;
        this.courseDraft.lmsActivityId = lmsActivityId;
      });
  }

  function hasBeenReleased() {
    return this.courseDraft.released;
  }

  function getSumTotalProp(props) {
    const { sumTotalIntegration = {} } = this.courseDraft;
    return (typeof props === 'object')
      ? props.map((prop) => sumTotalIntegration[prop])
      : sumTotalIntegration[props];
  }

  function disableActivityCode() {
    const hasActivityId = !!this.courseDraft?.lmsCourse?.externalCourseId;
    const hasActivityIdAndReleased = hasActivityId && this.hasBeenReleased();
    const isDemo = this.courseDraft.usedFor === CourseModel.USED_FOR_DEMO;
    return hasActivityIdAndReleased || this.courseDraft.isProgram || isDemo;
  }

  function disableValidateButton() {
    const hasActivityId = !!this.courseDraft?.lmsCourse?.externalCourseId;
    const hasActivityIdAndReleased = hasActivityId && this.hasBeenReleased();
    const editing = getSumTotalProp.call(this, 'editing');
    return !editing || hasActivityIdAndReleased;
  }

  function showValidationError() {
    const [validationError, editing, validating] = getSumTotalProp.call(this, ['validationError', 'editing', 'validating']);
    return validationError && !editing && !validating && this.courseDraft.lmsActivityCode;
  }

  function showSumTotalNotValidatedError() {
    if (this.forceShowSTValidationError) {
      return !this.isActivityValidated() && !this.disableValidateButton();
    }
    return false;
  }

  function focusToTitle(headerElement) {
    if (headerElement) {
      // Find the title container to scroll to it
      const titleContainer = headerElement.querySelector('.title-text, .title-textarea')?.closest('div');
      if (titleContainer) {
        // Scroll to the element first
        titleContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Try to focus the textarea if it exists (when in edit mode)
        const textarea = headerElement.querySelector('.title-textarea');
        if (textarea) {
          setTimeout(() => {
            textarea.focus();
          }, 100);
        } else {
          // If textarea doesn't exist, try to trigger edit mode by clicking the container
          const clickableContainer = titleContainer.closest('[role="button"]');
          if (clickableContainer) {
            clickableContainer.click();
            // Wait for textarea to appear, then focus it
            setTimeout(() => {
              const newTextarea = headerElement.querySelector('.title-textarea');
              if (newTextarea) {
                newTextarea.focus();
              }
            }, 150);
          }
        }
      }
    }
  }

  function focusToElement(element) {
    if (element) {
      setTimeout(() => {
        element.focus();
      }, 0);
    }
  }

  function checkRequiredFieldsAreFilled() {
    let scrollingElement = null;
    let focusType = null;
    // Check name validity
    if (!this.nameIsValid(this.courseDraft.name)) {
      // Use the React setter instead of vm property
      if (this.setShowTitleError) {
        this.setShowTitleError(true);
      }
      scrollingElement = document.getElementById('branding-header');
      focusType = 'title';
    }

    // Check catalog id validity
    if (this.courseForm.catalogId.$invalid) {
      if (!scrollingElement) {
        scrollingElement = document.getElementById('catalogId');
        focusType = 'element';
      }
      const ctrl = this.courseForm.catalogId;
      ctrl.$setTouched();
      ctrl.$setDirty();
      ctrl.$validate();
      this.courseForm.catalogId.$showValidationMessage = true;
    }

    const requiredMetadataFieldIds = (InstitutionsManager.institution?.metadataFields ?? [])
      .filter(field => field.required)
      .map(field => field.id);

    // Show error if there are required metadata fields
    if (
      requiredMetadataFieldIds.length > 0
      && this.setShowMetadataFieldError
    ) {
      this.setShowMetadataFieldError(true);
    }

    const missingRequiredMetadataFieldIds = requiredMetadataFieldIds
      .filter(fieldId => !(this.courseDraft?.courseMetadata ?? [])
        .some(item => item.metadataFieldId === fieldId && item.metadataValueId));

    if (missingRequiredMetadataFieldIds.length > 0 && this.setShowMetadataFieldError) {
      this.setShowMetadataFieldError(true);
      if (!scrollingElement) {
        scrollingElement = document.querySelector('.additional-metadata');
      }
    }

    if (this.hasSumTotalIntegration()
      && this.courseDraft.lmsActivityCode
      && !this.isActivityValidated()) {
      this.forceShowSTValidationError = true;
      if (!scrollingElement) {
        scrollingElement = document.getElementById('lmsActivityCode');
        // Trigger click to open the popover with the validation error message
        scrollingElement.click();
        focusType = 'element';
      }
    }

    if (scrollingElement) {
      $timeout(() => {
        $('#main-panel').scrollToElementAnimated(scrollingElement, 100, 200);
        if (focusType === 'title') {
          focusToTitle(scrollingElement);
        } else if (focusType === 'element') {
          focusToElement(scrollingElement);
        }
      }, 0);

      return false;
    }
    return true;
  }

  function showSuccessMessage() {
    const [editing, validating] = getSumTotalProp.call(this, ['editing', 'validating']);
    return !editing
      && !validating
      && this.courseDraft.lmsActivityCode
      && this.courseDraft.lmsActivityId;
  }

  function showValidateBtn() {
    const [validationError, editing] = getSumTotalProp.call(this, ['validationError', 'editing']);
    return !validationError || editing || !this.courseDraft.lmsActivityCode;
  }

  function isActivityValidated() {
    const [validationError, validating] = getSumTotalProp.call(this, ['validationError', 'validating']);
    return this.disableValidateButton() && !validationError && !validating;
  }

  function getValidateText() {
    const validating = getSumTotalProp.call(this, 'validating');
    return `COURSES.FORM.SUMTOTAL_INTEGRATION.${validating ? 'VALIDATING' : 'VALIDATE'}`;
  }

  vm.getTooltipMessage = function () {
    const missingCourseField = [];

    if (!this.isNameValid) {
      missingCourseField.push(t.COURSES.CLONE.COURSE_DETAILS.COURSE_NAME());
    }
    if (this.courseForm.catalogId?.$modelValue === undefined) {
      missingCourseField.push(t.COURSES.CLONE.COURSE_DETAILS.CATALOG_ID());
    }

    if (missingCourseField.length === 0 && this.pendingRequiredFields()) {
      return $translate.instant('COURSES.FORM.ERRORS.MANDATORY_FIELD_MISSING_MESSAGE');
    }
    if (missingCourseField.length === 1) {
      return $translate.instant('COURSES.FORM.ERRORS.FIELD_MISSING_MESSAGE', { missingCourseField: missingCourseField[0], isPendingField: this.pendingRequiredFields() });
    }

    if (missingCourseField.length === 2) {
      const formattedMissingFields = missingCourseField.join(`${t.JOIN.TWO.AND()}`);
      return $translate.instant('COURSES.FORM.ERRORS.FIELD_MISSING_MESSAGE', { missingCourseField: formattedMissingFields, isPendingField: this.pendingRequiredFields() });
    }
    return $translate.instant('COURSES.FORM.ERRORS.EMPTY_FIELDS_AND_ERRORS');
  };

  function showSubmitButton() {
    const isValidActivity = this.hasSumTotalIntegration() ? this.isActivityValidated() : true;
    const isTopicsRequired = vm.hasWorkdayIntegration
      && !this.courseDraft.isProgram
      && this.courseDraft.usedFor === vm.CourseModel.USED_FOR_PRODUCTION;
    const hasDefaultTopics = isTopicsRequired ? (this.courseDraft?.selectedTopics?.length > 0) : true;
    return this.courseForm.$valid
      && this.courseForm.$dirty
      && !this.savingCourse
      && this.isNameValid
      && isValidActivity
      && hasDefaultTopics;
  }

  function setCourseDurationUnit(unit) {
    // We must specifically use `this` here so that the value updates on the
    // implementing controllers
    this.courseDraft.durationType = unit;
    this.setDirty();
  }

  function setTags(newTags) {
    this.courseDraft.skill_tags = newTags.map(tag => tag.id).toString();
    $timeout(() => {
      this.setDirty();
    });
  }
  /**
   * Saves the set of metadata values in the course_metadata field.
   * @param newTags
   */
  function setMetadataTags(newTags) {
    this.courseDraft.courseMetadata = newTags;
    $timeout(() => {
      this.courseForm.$setDirty();
    });
  }

  function toggleSelectedTopic(topic) {
    if (!this.courseDraft.selectedTopics) {
      this.courseDraft.selectedTopics = [];
    }
    if (!this.courseDraft.selectedTopics.includes(topic)) {
      this.courseDraft.selectedTopics = [...this.courseDraft.selectedTopics, topic];
    } else {
      this.courseDraft.selectedTopics = this.courseDraft.selectedTopics.filter(selectedTopic => selectedTopic !== topic);
    }
    this.courseDraft.externalTags = this.courseDraft.selectedTopics.join(',');

    this.setDirty();
  }

  function onWorkdayTopicsDropdownToggle(isOpen) {
    if (isOpen) {
      return;
    }
    const isRequired = !this.courseDraft.isProgram
    && this.courseDraft.usedFor === vm.CourseModel.USED_FOR_PRODUCTION;
    this.workdayTopicsShowError = isRequired && (!this.courseDraft?.selectedTopics || this.courseDraft?.selectedTopics?.length === 0);
  }
  /**
   * If some field has the property 'required' it will be added / updated when
   * the page is loaded for the fisrt time or when the value is updated
   * @param {string} inputName
   * @param {number} value
   */
  function setRequiredField(inputName, value) {
    this.requiredFields[inputName] = value;
  }

  function removeRequiredField(inputName) {
    this.requiredFields = omit(this.requiredFields, [inputName]);
  }

  function nameIsValid(name) {
    if (_.isEmpty(name)) {
      return false;
    }

    return name.length <= MAX_NAME_LENGTH;
  }

  function setHeaderDraft(headerDraft) {
    _.extend(this.courseDraft, headerDraft);

    $timeout(() => {
      this.setDirty();
    });

    if (this.setNameValid && _.has(headerDraft, 'name')) {
      const isNameValid = nameIsValid(headerDraft.name);
      this.setNameValid(isNameValid);

      if (this.setShowTitleError) {
        this.setShowTitleError(!isNameValid);
      }
    }
  }

  /** We set this as a separate function instead of executing this during this file's initialize(), because this page uses angular.extend() to emulate subclassing this base-ctrl.
   * Any use of `this` or `vm` in this function will refer to the base-ctrl and _not_ the more specific class (like edit-course-ctrl) because angular.extend() copies props to the target
   * instead of modifying the source object */
  function renderReactCheckboxDropdown() {
    // list of skill tag object s
    const coursetags = CoursesManager.course.skillTags || [];
    render(
      <Provider store={store}>
        <AngularNvCheckboxDropdown
          courseTags={coursetags}
          // eslint-disable-next-line react/jsx-no-bind
          setTags={(items) => this.setTags(items)}
        />
      </Provider>,
      document.querySelector('#react-tags-dropdown'),
    );
  }

  /** We set this as a separate function instead of executing this during this file's initialize(), because this page uses angular.extend() to emulate subclassing this base-ctrl.
   * Any use of `this` or `vm` in this function will refer to the base-ctrl and _not_ the more specific class (like edit-course-ctrl) because angular.extend() copies props to the target
   * instead of modifying the source object */
  function renderReactDropdown() {
    const ReactDropdown = () => {
      const dispatch = useDispatch();
      const courseMetadataTags = this.courseDraft?.courseMetadata
        || CoursesManager.course.courseMetadata || [];
      const styles = css(`
        .tag-row {
          margin-top: ${threeQuartersSpacing}px;
        }
        span {
          padding: 0 ${quarterSpacing}px;
        }
        .bs4-dropdown-menu {
          width: 100%;
        }
        .has-error {
          border-color: red !important;
        }
      `);
      const [fields, setFields] = useState(InstitutionsManager.institution.metadataFields ?? []);
      const [missingRequiredMetadataFieldIds, setMissingRequiredMetadataFieldIds] = useState([]);
      const [showMetadataFieldError, setShowMetadataFieldError] = useState(false);

      const requiredFields = fields.filter(field => field.required).map(field => field.id);

      const checkMissingRequiredFields = (courseMetadata) => {
        if (showMetadataFieldError) {
          const missingFields = requiredFields
            .filter(fieldId => !(courseMetadata ?? [])
              .some(item => item.metadataFieldId === fieldId && item.metadataValueId));

          setMissingRequiredMetadataFieldIds(missingFields);
        }
      };

      // Check missing required fields when showMetadataFieldError changes to true
      useEffect(() => {
        checkMissingRequiredFields(this.courseDraft.courseMetadata);
      }, [showMetadataFieldError]);

      useEffect(() => {
        this.setShowMetadataFieldError = setShowMetadataFieldError;
        dispatch(getMetadataFilters({ callback: setFields }));
      }, []);

      const handleSetMetadataTags = (newTags) => {
        checkMissingRequiredFields(newTags);
        this.setMetadataTags(newTags);
      };

      return (
        <div css={styles}>
          {fields.map((field) => (
            <div
              className='tag-row'
              id={`metadatafield-${field.id}`}
              key={field.id}
            >
              <label className='gray-1-label preserve-space'>
                {field.name}
                {
                  field.required && (
                    <span className='text-danger'>
                      {t.COURSES.FORM.ADDITIONAL_METADATA.REQUIRED()}
                    </span>
                  )
                }
              </label>
              <AngularNvDropdownWrapper
                field={field}
                setRequiredField={this.setRequiredField.bind(this)}
                removeRequiredField={this.removeRequiredField.bind(this)}
                courseMetadataTags={courseMetadataTags}
                setMetadataTags={handleSetMetadataTags}
                showError={missingRequiredMetadataFieldIds.includes(field.id)}
              />
            </div>
          ))}
        </div>
      );
    };
    render(
      <Provider store={store}>
        <ReactDropdown />
      </Provider>,
      document.querySelector('#react-metadata-tags-dropdown'),
    );
  }

  function getEntitlementProfileSettingName(entitlement) {
    return profileSettings.find((profileSetting) => (profileSetting.id === entitlement.profileSettingId))?.name;
  }

  function getEntitlementValuesText(entitlement) {
    return i18nJoin(entitlement.values, JoinMode.OR);
  }

  function shouldShowPrimaryOption() {
    return (
      CurrentPermissionsManager.hasOrgAdminPermissions()
      || CurrentPermissionsManager.hasCourseManagerPermissions()
    ) && !this.courseDraft.isProgram && !this.courseDraft.isCohort && (this.isEdit ? !this.courseDraft.isPrimary : true);
  }
}

/**
 * A react component that wraps <NvCheckboxDropdown/>, used for selecting institution tags for this course.
 * @param availableTags The list of tags available on this institution. A NvCheckboxDropdownItem[]
 * @param courseTags The tags already set on this course. A list of strings.
 * @param setTags A callback that updates the AngularJS model of which tags are currently selected.
 */
const AngularNvCheckboxDropdown = ({ courseTags, setTags }) => {
  useEffect(() => {
    dispatch(getAllSkillTags({ institutionId: currentInstitutionId }));
  }, []);

  const dispatch = useAppDispatch();
  const currentInstitutionId = useSelector(
    (state) => state.app.currentInstitutionId,
  );

  // const defaultTags = courseTags ? [...courseTags] : [];
  const allTags = Object.values(useSelector((state) => state.models.skillTags)).map(
    (tag, i) => ({
      id: tag.id,
      name: tag.name,
      label: tag.name,
    }),
  ).sort(((a, b) => a.name.localeCompare(b.name)));

  const selectedTags = courseTags ? [...courseTags] : [];
  const methods = useForm({
    mode: 'onChange',
    shouldUnregister: true,
    defaultValues: {
      tagsDropdown: selectedTags,
    },
  });

  // Update the current list of selected tags, and fire the tag selected callback
  const onTagClicked = (selecteditem, index, values) => {
    setTags(values);
  };

  return (
    <AppStylesProvider>
      <FormProvider {...methods}>
        <form>
          <NvCheckboxDropdown
            name='tagsDropdown'
            items={allTags}
            onChange={(item, index, values) => onTagClicked(item, index, values)}
            dropdownProps={{
              flip: false,
            }}
            prompt={t.INSTITUTIONS.SKILL_TAGS.COURSE_PROMPT()}
            noItemsText={t.INSTITUTIONS.SKILL_TAGS.COURSE_NO_TAGS()}
          />
        </form>
      </FormProvider>
    </AppStylesProvider>
  );
};

/**
 * A react component that wraps <NvDropdown/>, used for selecting metadata tags for this course.
 * @param field The info of a metadata field, included metadata value tags available on this institution.
 * @param courseMetadataTags The metadata tags already set on this course. A list of Objects.
 * @param setMetadataTags A callback that updates the AngularJS model of which tags are currently selected.
 */
const AngularNvDropdownWrapper = (props) => {
  const {
    field,
    courseMetadataTags,
    setRequiredField,
    removeRequiredField,
    setMetadataTags,
    showError = false,
  } = props;
  const methods = useForm({
    mode: 'onChange',
    defaultValues: {},
  });

  const nvDropDownName = `metadataTagsDropdown_${field.id}`;

  return (
    <AppStylesProvider>
      <FormProvider {...methods}>
        <Controller
          name={nvDropDownName}
          render={() => (
            <MetadataNvDropdown
              field={field}
              courseMetadataTags={courseMetadataTags}
              setRequiredField={setRequiredField}
              removeRequiredField={removeRequiredField}
              showError={showError}
              setMetadataTags={setMetadataTags}
            />
          )}
        />
      </FormProvider>
    </AppStylesProvider>
  );
};
